var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "popup__layer active" }, [
    _c("div", { staticClass: "popup__edit" }, [
      _c(
        "div",
        {
          staticClass: "popup__close",
          on: {
            click: function($event) {
              return _vm.close(true)
            }
          }
        },
        [_c("span", { staticClass: "glicon-close-large" })]
      ),
      _c("div", { staticClass: "popup__feedback" }, [
        _vm._m(0),
        _c("div", { staticClass: "popup__feedback--subtitle" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("account.forms.deactivateMailAnimationTitle")) +
              " "
          )
        ]),
        _c("div", { staticClass: "popup__feedback--text" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("account.forms.deactivateMailAnimationText")) +
              " "
          )
        ]),
        _c("div", { staticClass: "popup__feedback--text failed" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("account.forms.deactivateMailAnimationWarning")) +
              " "
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "popup__buttons" },
        [
          _c("gl-button", {
            attrs: {
              id: "config.deactivate-mail",
              "color-secondary": "",
              type: "button",
              text: _vm.$t("account.forms.deactivateMailAnimation")
            },
            on: {
              onClick: function($event) {
                $event.preventDefault()
                return _vm.close(false)
              }
            }
          }),
          _c("gl-button", {
            attrs: {
              id: "config.activate-mail",
              "color-primary": "",
              type: "button",
              text: _vm.$t("account.forms.activateMailAnimation")
            },
            on: {
              onClick: function($event) {
                $event.preventDefault()
                return _vm.close(true)
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "popup__feedback--image failed" }, [
      _c("span", { staticClass: "glicon-alert-thin" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }